<div class="config-wizard-container">
  <h1 mat-dialog-title>{{ 'labels.heading.Welcome to LOS' | translate }}</h1>

  <mat-dialog-content class="config-wizard-content">
    <p class="description">{{ 'labels.heading.Configure LOS Organization Needs' | translate }}</p>

    <div class="buttons-grid">
      <button mat-raised-button color="primary" [mat-dialog-close]="{ show: 1 }">
        {{ 'labels.buttons.Home Screen Tour' | translate }}
      </button>
      <button mat-raised-button color="primary" [mat-dialog-close]="{ show: 2 }">
        {{ 'labels.buttons.Setup Organization' | translate }}
      </button>
      <button mat-raised-button color="primary" [mat-dialog-close]="{ show: 3 }">
        {{ 'labels.buttons.Setup System' | translate }}
      </button>
      <button mat-raised-button color="primary" [mat-dialog-close]="{ show: 4 }">
        {{ 'labels.buttons.Setup Accounting' | translate }}
      </button>
      <button mat-raised-button color="primary" [mat-dialog-close]="{ show: 5 }">
        {{ 'labels.buttons.Setup Products' | translate }}
      </button>
      <button mat-raised-button color="primary" [mat-dialog-close]="{ show: 6 }">
        {{ 'labels.buttons.Setup Funds and Reports' | translate }}
      </button>
    </div>

    <div class="progress-section">
      <h3 class="progress-label">{{ 'labels.heading.Progress Bar' | translate }}: 0%</h3>
      <mat-progress-bar mode="determinate" value="0"></mat-progress-bar>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="config-wizard-actions">
    <button mat-raised-button color="warn" [mat-dialog-close]="{ show: 0 }">
      {{ 'labels.buttons.Close Config. Wizard' | translate }}
    </button>
  </mat-dialog-actions>
</div>
